import { useEffect, useState, useRef } from "react";
import { Dropdown, Button, Form, Image } from "react-bootstrap";
import { Search, ThreeDotsVertical, XLg } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { downLoadReport, fetchClientList } from "../../../store/actions/clientsAction";
import { userSearch } from "../../../store/reducerSlice/clients";
import TableDesign from "../../common/table/TableDesign";
import DeleteClientPopup from "./DeleteClientPopup";
import ToggelActivatateClientPopup from "./ToggelActivatateClientPopup";
import ResetPasswordClientPopup from "./ResetPasswordClientPopup";
import ManageClient from "./ManageClient";
import ActivationLinkClientPopup from "./ActivationLinkClientPopup";
import ProfileImage from "../../../assets/images/profile.svg";
import { resetPopup, userReset } from "../../../store/reducerSlice/clients";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import Loader from "../../common/loader/Loader";

const tableHeadings = [
  {
    label: "S.No.",
  },

  {
    label: "Geography",
  },
  {
    label: "Ward Type",
  },
  {
    label: "Admin Name",
    sort: "contactName",
  },
  {
    label: "Admin Email",
    sort: "clientEmail",
  },
  {
    label: "Register On",
  },
  {
    label: "Status",
    sort: "status",
  },
  {
    label: "Action",
  },
];

const debounce = (func, timeout = 500) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

const ClientsList = () => {
  const searchInputRef = useRef(null);
  const [searchText, setSearchText] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [selectclient, setselectclient] = useState(null);
  const [filterOption, setFilterOption] = useState({
    page: 1,
    search: "",
    orderBy: "created",
    orderIn: -1,
  });
  const [message, setMessage] = useState(null);
  const [title, setTitle] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [deleteRec, setDeleteRec] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [toggleActivateRec, setToggleActivateRec] = useState(null);
  const [toggleActivateStatus, setToggleActivateStatus] = useState(null);
  const [toggleActivateModalShow, setToggleActivateModalShow] = useState(false);
  const [activationLinkRec, setActivationLinkRec] = useState(null);
  const [activationLinkModalShow, setActivationLinkModalShow] = useState(false);
  const [resetPasswordRec, setResetPasswordRec] = useState(null);
  const [resetPasswordModalShow, setResetPasswordModalShow] = useState(false);

  // get user store value
  const user = useSelector((state) => state.user);

  const { userDetail } = user;
  const admin = useSelector((state) => state.admin);
  const { adminDetail } = admin;
  // get user store value
  const dispatch = useDispatch();
  const {
    clients,
    filtered,
    downloadClientList,
    pagination,
    isLoader,
    isRecordUpdated,
    isRecordAdded,
    error: apiError,
  } = useSelector((state) => {
    return state.clients;
  });
  const page = pagination?.currentPage;

  const cc = filtered || clients;

  useEffect(() => {
    dispatch(fetchClientList(filterOption));
  }, [filterOption, isRecordUpdated]);

  const filterHandler = (obj) => {
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  useEffect(() => {
    if (searchText || searchText === "") {
      filterHandler({ search: searchText, page: 1 });
    }
  }, [searchText]);

  const hideHandle = () => {
    setModalShow(false);
    setselectclient(null);
    setDeleteModalShow(false);
    setDeleteRec(null);
    setToggleActivateModalShow(false);
    setToggleActivateRec(null);
    setActivationLinkModalShow(false);
    setActivationLinkRec(null);
    setResetPasswordModalShow(false);
    setResetPasswordRec(null);
  };

  const createUpdateClient = (client) => {
    dispatch(resetPopup());
    setModalShow(true);
    setselectclient(client);
    setTitle("Update Admin");
    setMessage("Admin updated successfully!");
    setShowResult(true);
  };

  const addNewClient = () => {
    dispatch(resetPopup());
    setselectclient(null);
    setModalShow(true);
    setTitle("Add Admin");
    setMessage(
      "Admin has been added successfully. An account activation link is sent to their registered email"
    );
    setShowResult(true);
  };

  window.history.replaceState({}, document.title);
  const downloadClient = () => {
    const { orderBy, orderIn } = filterOption;
    dispatch(downLoadReport({orderBy, orderIn}));
  };

  useEffect(() => {
    if (downloadClientList) {
      window.open(
        downloadClientList,
        "_blank" // <- This is what makes it open in a new window.
      );
    }
  }, [downloadClientList]);

  const deleteEventHandler = (rec) => {
    dispatch(resetPopup());
    setDeleteRec(rec?._id);
    setDeleteModalShow(true);
    setTitle("Delete Admin");
    setMessage("Admin deleted successfully!");
    setShowResult(true);
  };

  const toggleActivateEventHandler = (rec) => {
    dispatch(resetPopup());
    setToggleActivateRec(rec?._id);
    setToggleActivateStatus(rec?.status);
    setToggleActivateModalShow(true);
    if (rec?.status === "INACTIVE") {
      setTitle("Activate Admin");
      setMessage("Admin activated successfully!");
    } else {
      setTitle("Deactivate Admin");
      setMessage("Admin deactivated successfully!");
    }
    setShowResult(true);
  };

  const activationLinkEventHandler = (rec) => {
    dispatch(resetPopup());
    setActivationLinkRec(rec?._id);
    setActivationLinkModalShow(true);
    setTitle("Send Activation Link");
    setMessage("Activation link sent successfully!");
    setShowResult(true);
  };

  const resetPasswordEventHandler = (rec) => {
    dispatch(resetPopup());
    setResetPasswordRec(rec?._id);
    setResetPasswordModalShow(true);
    setTitle("Send Reset Password Link");
    setMessage("Reset password link sent successfully!");
    setShowResult(true);
  };

  const formatedDate = (val) => {
    var options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(val).toLocaleDateString("nl-NL", options);
  };

  const hideHandlerRes = () => {
    dispatch(resetPopup());
    setTitle(null);
    setMessage(null);
    setShowResult(false);
  };

  return (
    <>
     
        <ManageClient
          show={modalShow}
          onHide={hideHandle}
          title={selectclient ? "Edit Admin" : "Add Admin"}
          selectclient={selectclient}
          setModalShow={setModalShow}
          adminDetail={adminDetail}
        />

        <DeleteClientPopup
          onHide={hideHandle}
          deleteRec={deleteRec}
          deleteModalShow={deleteModalShow}
          setDeleteModalShow={setDeleteModalShow}
        />
        <ToggelActivatateClientPopup
          onHide={hideHandle}
          toggleActivateRec={toggleActivateRec}
          toggleActivateStatus={toggleActivateStatus}
          toggleActivateModalShow={toggleActivateModalShow}
          setToggleActivateModalShow={setToggleActivateModalShow}
        />
        <ActivationLinkClientPopup
          onHide={hideHandle}
          activationLinkRec={activationLinkRec}
          activationLinkModalShow={activationLinkModalShow}
          setActivationLinkModalShow={setActivationLinkModalShow}
        />
        <ResetPasswordClientPopup
          onHide={hideHandle}
          resetPasswordRec={resetPasswordRec}
          resetPasswordModalShow={resetPasswordModalShow}
          setResetPasswordModalShow={setResetPasswordModalShow}
        />
        <h1 className="main-title">Manage Admin</h1>
        <div className="block">
        {/* <Button
            className="btn-primary border-0"
            href="#"
            style={{
              float: "right",
              boxShadow: "0px 4px 4px 0px rgba(133, 93, 217, 0.5)",
              marginLeft: "10px",
            }}
            onClick={() => downloadClient()}
          >
            Download
          </Button> */}
          {adminDetail?.wardTypes && !adminDetail?.isAdmin && adminDetail?.wardTypes.length === 0 ? (
            ""
          ) :!adminDetail?.wardTypes?.includes("none") && (
            <Button
              className="btn-primary"
              href="#"
              style={{ float: "right" }}
              onClick={() => addNewClient()}
            >
              Add Admin
            </Button>
          )}

          <div className="searchForm">
            <Search className="searchSvg1" />
            <Form.Control
              type="text"
              name="search"
              ref={searchInputRef}
              placeholder="Search"
              onKeyUp={debounce((e) => setSearchText(e.target.value), 200)}
            />
            {searchText?.length > 0 && (
              <XLg
                className="searchSvg2"
                onClick={(e) => {
                  searchInputRef.current.value = "";
                  setSearchText("");
                }}
              />
            )}
          </div>
        </div>
        <TableDesign
          className="mt-5 pt-4"
          {...{
            title: "List of All Admins",
            tableHeadings,
            filterHandler,
            pagination,
            filterOption,
            setFilterOption,
            isLoader,
          }}
        >
          {isLoader && <Loader />}
          {cc && cc.length ? (
            cc.map((row, i) => {
              if (row)
                return (
                  <tr key={i} className="align-items-center">
                    <td align="center">
                      {i + 1 + (page > 1 && (page - 1) * 10)}
                    </td>
                    <td>
                      {row?.locations.length > 0 &&
                        row?.locations
                          .map((item) => {
                            return item.name;
                          })
                          .join(",")}
                    </td>
                    <td>
                      {row?.wardTypes.length > 0 &&
                        row?.wardTypes
                          .map((item) => {
                            return item.replace("IMC-STROKE", "IMC/STROKE");
                          })
                          .join(",")}
                    </td>
                    <td className="py-auto">{row.contactName}</td>
                    <td>{row.clientEmail}</td>
                    <td>{formatedDate(row.createdAt)}</td>

                    <td>
                      {row.isActivated ? (
                        row.status === "ACTIVE" ? (
                          <span style={{ color: "#10940D", fontWeight: 600 }}>
                            Active
                          </span>
                        ) : (
                          <span style={{ color: "red", fontWeight: 600 }}>
                            Inactive
                          </span>
                        )
                      ) : (
                        <span style={{ color: "#F8A80C", fontWeight: 600 }}>
                          Pending
                        </span>
                      )}
                    </td>
                    <td align="center">
                     {row.isClientLocation && row.isClientWardType && !row?.isAdmin ? (
                        <Dropdown align="end">
                          <Dropdown.Toggle>
                            <ThreeDotsVertical />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              href="#"
                              onClick={() => createUpdateClient(row)}
                            >
                              Edit
                            </Dropdown.Item>
                            {!row.isActivated ? (
                              <>
                                <Dropdown.Item
                                  href="#"
                                  onClick={() => deleteEventHandler(row)}
                                >
                                  Delete
                                </Dropdown.Item>
                                <Dropdown.Item
                                  href="#"
                                  onClick={() =>
                                    activationLinkEventHandler(row)
                                  }
                                >
                                  Resend Activation
                                </Dropdown.Item>
                              </>
                            ) : (
                              <>
                                {row.status === "INACTIVE" ? (
                                  <>
                                    <Dropdown.Item
                                      href="#"
                                      onClick={() =>
                                        toggleActivateEventHandler(row)
                                      }
                                    >
                                      Activate
                                    </Dropdown.Item>
                                  </>
                                ) : (
                                  <>
                                    <Dropdown.Item
                                      href="#"
                                      onClick={() =>
                                        toggleActivateEventHandler(row)
                                      }
                                    >
                                      Deactivate
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      href="#"
                                      onClick={() =>
                                        resetPasswordEventHandler(row)
                                      }
                                    >
                                      Reset Password
                                    </Dropdown.Item>
                                  </>
                                )}
                              </>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      ) : null}
                    </td>
                  </tr>
                );
            })
          ) : (
            <>
              {!isLoader && (
                <tr>
                  <td colSpan="8">No Result Found</td>
                </tr>
              )}
            </>
          )}
        </TableDesign>
      
      {(isRecordUpdated || isRecordAdded) && showResult && (
        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordAdded,
            isRecordUpdated,
            successMsg: message,
            title: title,
          }}
        />
      )}
    </>
  );
};

export default ClientsList;
